export const REMOVE_HISTORY_BET = 'REMOVE_HISTORY_BET';
export const REMOVE_HISTORY_BETS = 'REMOVE_HISTORY_BETS';

export const REQUEST_BET_TYPES = 'REQUEST_BET_TYPES';
export const SUCCESS_REQUEST_BET_TYPES = 'SUCCESS_REQUEST_BET_TYPES';
export const FAILURE_REQUEST_BET_TYPES = 'FAILURE_REQUEST_BET_TYPES';



// WEBPACK FOOTER //
// ./js/actions/HistoryBet.js